/**
 * Contradictions Block Configuration
 *
 * Registry config for the document contradictions block type.
 */

import { AlertCircle } from "lucide-react";
import { ContradictionsBlock } from "@/canvas/components/blocks/ContradictionsBlock";
import type { BlockConfig } from "../types";

export const contradictionsBlockConfig: BlockConfig<"contradictions"> = {
  type: "contradictions",
  component: ContradictionsBlock,
  icon: AlertCircle,
  iconClassName: "text-red-500",
  label: "canvas.blockTypes.contradictions",
  defaultContent: () => ({ items: [] }),
  showInAddBlockMenu: true,
};
